import { MuseumDataType } from '@portalCommon/constants';
import { OptimizedImg } from '@commonPackage/components';
import cx from './index.module.less';

interface Props {
  dataSource: MuseumDataType[];
  className?: string;
}

export const SceneCards = (props: Props) => {
  const { dataSource, className } = props;
  return (
    <>
      <div className={cx(className, 'cards-wrapper')}>
        {dataSource.map((data, idx) => (
          <div className={cx('card')} key={`${idx}_${data.title}`}>
            <OptimizedImg src={data.imgSrc} alt="" />
            <div className={cx('title')}>{data.title}</div>
            <div className={cx('brief')}>{data.brief}</div>
          </div>
        ))}
      </div>
      <p className={cx('foot-text')}>更多应用场景等您探索</p>
      <p className={cx('foot-text')}>···</p>
    </>
  );
};
